import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './features/home/home.component';
import { RentalPropertiesComponent } from './features/rental-properties/rental-properties.component';
import { SalesPropertiesComponent } from './features/sales-properties/sales-properties.component';
import { NewProjectsComponent } from './features/new-projects/new-projects.component';
import { AreasComponent } from './features/areas/areas.component';
import { AboutComponent } from './features/about/about.component';
import { ContactComponent } from './features/contact/contact.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ViewDetailsComponent } from './features/view-details/view-details.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    RentalPropertiesComponent,
    SalesPropertiesComponent,
    NewProjectsComponent,
    AreasComponent,
    AboutComponent,
    ContactComponent,
    ViewDetailsComponent,
    SafeUrlPipe, // ✅ add this
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
